/**
 * @providesModule EmailVerifyStyle
 * 
 */

import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  Platform,
} from 'react-native';

const {
  viewCornerRadiusPrimary,
  viewPrimaryColor,
  textColorPrimary,
  textColorSecondary,
  btnTextColorOne,
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
  opacityTertiary,
  fontRegular,
  fontSecondary,
} = SkillzStyle.fullStyles;


const styles = StyleSheet.create({
  mainContainer: {
    ...Platform.select({
      web: {
        height: '100%',
      }
    })
  },
  backgroundContainer: {
    flex: 1,
    alignSelf: Sizes.select({
      phone: 'stretch',
      tablet: 'center',
    }),
    backgroundColor: SkillzStyle.convertToOpacity(
      viewPrimaryColor.backgroundColor,
      opacityTertiary
    ),
    ...Sizes.select({
      phone: {},
      tablet: {flexGrow: 1, justifyContent: 'center', alignItems: 'center', flexDirection: 'row'},
    }),
  },

  mailImageStyle: {
    alignSelf: 'center',
    ...Sizes.select({
      landscapePhone: {
        width: 180,
        height: 110,
      },

      tablet: {
        width: 245,
        height: 195,
        marginBottom: -10,
      },
      portraitPhone: {
        width: 196,
        height: 112,
        marginTop: 10,
        marginBottom: 10,
      },
    }),
  },

  footerButtonContainer: {
    justifyContent: 'center',
    ...viewCornerRadiusPrimary,
    marginTop: Sizes.select({
      portraitPhone: 15,
      landscapePhone: 5,
      tablet: 10,
    }),
  },

  pushBtnContainer: {
    height: Sizes.select({
      portraitPhone: 40,
      landscapePhone: 35,
      tablet: 50,
    }),
    marginHorizontal: Sizes.select({
      phone: 0,
      tablet: 30,
    }),
  },

  pushBtnText: {
    ...fontSecondary,
    ...btnTextColorOne,
    ...fontSizeH2,
  },

  divider: {
    ...Sizes.select({
      landscapePhone: {
        width: Sizes.screenWidth * .8,
        height: 1,
        marginVertical: 10,
      },
      tablet: {
        height: StyleSheet.hairlineWidth,
        marginVertical: 20,
      },
      portraitPhone: {
        height: StyleSheet.hairlineWidth,
        marginVertical: Sizes.select({
          small: 10,
          large: 20,
        }),
      },
    }),
  },

  messageAndEmailContainer: {
    ...viewCornerRadiusPrimary,
    padding: 6,
    marginHorizontal: Sizes.select({
      portrait: 10,
      landscape: 25,
    }),
    alignSelf: 'center',
  },

  emailInputText: {
    textAlign: 'center',
    color: 'black',
    ...fontSizeH3,
    flex: 1,
    flexGrow: 1,
  },

  emailInputContainer: {
    backgroundColor: 'white',
    ...viewCornerRadiusPrimary,
    marginTop: 6,
    marginHorizontal: Sizes.select({
      phone: 0,
      tablet: 30,
    }),
    ...Platform.select({
      ios: {
        height: Sizes.select({
          portraitPhone: 45,
          largeLandscapePhone: 35,
          smallLandscapePhone: 30,
          other: 50,
        }),
      },
      android: {
        height: Sizes.select({
          portraitPhone: 45,
          largeLandscapePhone: 40,
          smallLandscapePhone: 35,
          other: 50,
        }),
      },
    }),
  },

  messageContainer: {
    flexDirection: 'column',
    alignItems: 'center',
  },

  emailVerifyLabel: {
    ...fontSecondary,
    ...textColorPrimary,
    ...Sizes.select({
      portraitPhone: fontSizeH1,
      largeLandscapePhone: fontSizeH1,
      smallLandscapePhone: fontSizeH2,
      tablet: fontSizeH1,
    }),
    textAlign: 'center',
    alignSelf: 'center',
    marginVertical: Sizes.select({
      landscapePhone: 2,
      other: 6,
    }),
  },

  requireMessageLabel: {
    ...textColorPrimary,
    marginHorizontal: Sizes.select({
      portraitPhone: 12,
      landscapePhone: 15,
      tablet: 200,
    }),
    marginVertical: Sizes.select({
      portraitPhone: 6,
      landscapePhone: 0,
      tablet: 6,
    }),
    ...Sizes.select({
      landscapePhone: {height: 35},
      other: {},
    }),
    ...Sizes.select({
      landscapePhone: fontSizeH2,
      other: fontSizeH3,
    }),
    textAlign: 'center',
  },

  titleText: {
    ...fontSecondary,
    ...Sizes.select({
      phone: fontSizeH3,
      tablet: fontSizeH2,
    }),
    ...textColorSecondary,
    textAlign: 'center',
  },

  messageText: {
    ...Sizes.select({
      phone: fontSizeH4,
      tablet: fontSizeH3,
    }),
    ...fontRegular,
    ...textColorSecondary,
    paddingVertical: 20,
    paddingHorizontal: 40,
    textAlign: 'center',
  },

  buttonText: {
    ...fontSecondary,
    ...Sizes.select({
      phone: fontSizeH5,
      tablet: fontSizeH4,
    }),
    ...btnTextColorOne,
  },
});


export default styles;
